import { PopupContent } from '@/components/PagePopup/PopupContent';
import { Button, Text } from '@music-vine/cadence/ui';
import type { PagePopupProps, PopUpPosition, PopUpVariant } from '@/components/PagePopup/PagePopup';
const subtitle = 'PARTNER PROGRAM';
const title = 'Earn 30% commission on every paid referral';
const description = 'Share your link and earn recurring commission whenever your audience subscribes.';
const ctaLabel = 'Apply to become a partner';

// Homepage, Pricing, Account area, Download history, Boards, Blog (DEV-6570),
// plus the Refer & Earn page itself, which already pitches the program
const excludedRoutes = [/^\/(?:[?#]|$)/, /^\/pricing/, /^\/my\/account/, /^\/my\/downloads/, /^\/my\/boards/, /^\/blog/, /^\/refer-and-earn/];
export const getReferralProgramProps = ({
  logPopupClick,
  asPath,
  onApply
}: {
  logPopupClick: (type: string, popup_id: string, nextPath: string) => void;
  asPath: string;
  /** Opens the in-app partner application journey (DEV-6758) */
  onApply: () => void;
}): PagePopupProps | null => {
  const popupId = 'partner-program';
  const handleApplyClick = () => {
    logPopupClick('cta', popupId, 'partner-application');
    window.postMessage({
      type: 'DISMISS_POPUP'
    }, '*');
    onApply();
  };
  return {
    storageKey: popupId,
    variant: 'default' as PopUpVariant,
    position: 'bottom-right' as PopUpPosition,
    excludeSlugs: excludedRoutes,
    children: <PopupContent mainTitle={title} subtitle={subtitle} variant="default">
        <Text className="text-pretty font-sans text-sm tracking-tight">
          {description}
        </Text>
        <Button className="w-full text-sm" onClick={handleApplyClick} variant="bold">
          {ctaLabel}
        </Button>
      </PopupContent>,
    onClickDismiss: () => {
      logPopupClick('dismiss', popupId, asPath);
    },
    onShow: () => {
      logPopupClick('impression', popupId, asPath);
    },
    noXIcon: {
      desktop: false,
      mobile: false
    },
    mobileChildren: <PopupContent mainTitle={title} subtitle={subtitle} variant="mobile-banner-default">
        <Text className="text-balance text-center font-sans text-gray-700 text-sm tracking-tight dark:text-gray-200">
          {description}
        </Text>
        <Button className="mt-2 w-full" fontSize="sm" onClick={handleApplyClick} size="lg" variant="brand">
          {ctaLabel}
        </Button>
      </PopupContent>
  };
};